import * as Sentry from '@sentry/react';
import React, { createContext, useContext, useEffect, useState } from 'react';

const onlinePollingInterval = 10000;

const OnlineStatusContext = createContext(true);

export const OnlineStatusProvider: React.FC = ({ children }) => {
  const [onlineStatus, setOnlineStatus] = useState<boolean>(navigator.onLine);

  useEffect(() => {
    Sentry.setContext('onlineStatus', { onlineStatus });
  }, [onlineStatus]);

  const checkStatus = async () => {
    setOnlineStatus(navigator.onLine);
  };

  useEffect(() => {
    checkStatus();
    window.addEventListener('offline', () => {
      setOnlineStatus(false);
    });
    window.addEventListener('online', () => {
      setOnlineStatus(true);
    });

    // Add polling incase of slow connection
    const id = setInterval(() => {
      checkStatus();
    }, onlinePollingInterval);

    return () => {
      window.removeEventListener('offline', () => {
        setOnlineStatus(false);
      });
      window.removeEventListener('online', () => {
        setOnlineStatus(true);
      });
      clearInterval(id);
    };
  }, []);

  return (
    <OnlineStatusContext.Provider value={onlineStatus}>{children}</OnlineStatusContext.Provider>
  );
};

export const useOnlineStatus = () => {
  const store = useContext(OnlineStatusContext);
  return store;
};

export default useOnlineStatus;
